export const isPhone = width => width < 768;
